import { __decorate, __metadata } from "tslib";
import { IsInt, IsPositive, Min, ValidateIf } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { PAGINATION_LIMIT } from '../constants';
import { StoreItemsExposeGroup } from '../enum';
export class PaginationDto {
    constructor() {
        this.skip = 0;
        this.take = PAGINATION_LIMIT;
    }
}
__decorate([
    ApiProperty({ type: () => Number, description: 'How many items to skip from start of the list', default: 0, example: 25 }),
    Expose({ groups: [StoreItemsExposeGroup.REQUEST, StoreItemsExposeGroup.READ] }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    Type(() => Number),
    __metadata("design:type", Number)
], PaginationDto.prototype, "skip", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'How many items to return', default: PAGINATION_LIMIT, example: 25 }),
    Expose({ groups: [StoreItemsExposeGroup.REQUEST, StoreItemsExposeGroup.READ] }),
    ValidateIf((_object, value) => !!value),
    IsInt({ always: true }),
    IsPositive({ always: true }),
    Type(() => Number),
    __metadata("design:type", Number)
], PaginationDto.prototype, "take", void 0);
//# sourceMappingURL=PaginationDto.js.map